import type { Column } from '@rundown-studio/types'
import { useUser } from '../../user/api/hooks.ts'
import { getAllowedColumns } from '../utils/get-allowed-columns'

type ReturnType = {
  getAllowedColumns: (columns: Column[]) => Column[]
}

/**
 * Hook that provides functionality to filter private note columns
 * based on the current user's permissions.
 *
 * @returns {{
 *   filterPrivateNotesColumn: (columns: Column[]) => Column[]
 * }} Object containing the `filterPrivateNotesColumn` function, which filters columns to show only public columns and private columns owned by the current user.
 */
export const useGetAllowedColumns = (): ReturnType => {
  const { data: user } = useUser()

  return {
    /**
     * Filters columns to show only public columns and private columns owned by the current user.
     *
     * @param {Column[]} columns - Array of RundownColumns to filter.
     * @returns {Column[]} Filtered array of RundownColumns.
     */
    getAllowedColumns(columns: Column[]): Column[] {
      return getAllowedColumns(columns, user?.uid)
    },
  }
}
